(function() {
  'use strict';
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  async function init() {
    const section = document.getElementById('tile-calculator-section');
    if (!section) return;

    function safeParseFloat(val) {
      if (val === null || val === undefined || val === '') return 0;
      return parseFloat(String(val).replace(',', '.')) || 0;
    }

    const productData = {
      id: section.dataset.productId,
      handle: section.dataset.productHandle,
      title: section.dataset.productTitle,
      coverage: safeParseFloat(section.dataset.coverage),
      tileType: section.dataset.tileType,
      minGrout: safeParseFloat(section.dataset.minGrout) || 2,
      tileSize: section.dataset.tileSize,
      tileSurface: section.dataset.tileSurface,
      groutProductHandle: section.dataset.groutProduct,
      floorAdhesiveHandle: section.dataset.floorAdhesive,
      wallAdhesiveHandle: section.dataset.wallAdhesive,
      leadTime: parseInt(section.dataset.leadTime) || 0,
      leadTimeEnabled: section.dataset.leadTimeEnabled === 'true',
      boxCoverage: safeParseFloat(section.dataset.boxCoverage),
      tilesPerBox: parseInt(section.dataset.tilesPerBox) || 0,
      subfloorRecs: section.dataset.subfloorRecommendations === 'true',
      decouplingMatHandle: section.dataset.decouplingMat,
      pricePerSqm: 0,
      currency: section.dataset.currency || 'GBP'
    };

    if (!productData.coverage || productData.coverage <= 0) {
      const addToCartBtn = document.getElementById('calculate-and-add');
      if (addToCartBtn) {
        addToCartBtn.disabled = true;
        addToCartBtn.innerHTML = 'Please contact us for a quote on this product';
      }
      console.warn('tile-features: coverage metafield is missing or zero for this product.');
      return;
    }

    const FLOOR_ADHESIVE_COVERAGE = 4.5;
    const WALL_ADHESIVE_COVERAGE  = 6.5;

    let areas = [{ length: '', width: '', area: 0, surface: getDefaultSurface() }];
    let wasteEnabled = false;
    let wastePercent = 10;
    let selectedSubfloor = 'concrete';
    let tileDimensions = null;
    let selectedGroutColor = 'white';
    let calculatorReady = false;
    let currentBoxInfo = { boxes: 0, actualArea: 0, extraWaste: 0 };
    let currentRawTotalArea = 0;
    
    window.adhesiveData = { isReady: false, items: [] };
    window.groutData = { variantId: null, bags: 0, jointWidth: null, color: 'white', isReady: false };
    window.decouplingData = { variantId: null, quantity: 0, isReady: false };

    const areasContainer = document.getElementById('tile-calc__areas');
    const addAreaBtn = document.getElementById('tile-calc__add-area');
    const wasteToggle = document.getElementById('tile-calc__waste-toggle');
    const wasteControls = document.getElementById('tile-calc__waste-controls');
    const patternSelect = document.getElementById('tile-calc__pattern');
    const wastePctInput = document.getElementById('tile-calc__waste-pct');
    const resultsDiv = document.getElementById('tile-calc__results');
    const adhesiveSection = document.getElementById('tile-adhesive');
    const groutSection = document.getElementById('tile-grout');
    const groutJointInput = document.getElementById('grout-joint-mm');
    const minGroutHint = document.getElementById('min-grout-hint');
    const sampleBtn = document.getElementById('tile-sample__btn');
    const sampleCounterSpan = document.getElementById('tile-sample__counter');
    const addToCartBtn = document.getElementById('calculate-and-add');
    const subfloorRadios = document.querySelectorAll('input[name="subfloor"]');
    const subfloorWarning = document.getElementById('subfloor-warning');
    const subfloorRecommendationsDiv = document.getElementById('subfloor-recommendations');
    const decouplingMatToggle = document.getElementById('decoupling-mat-toggle');
    const colorSwatches = document.querySelectorAll('.color-swatch');

    function getDefaultSurface() {
      const canFloor = productData.tileSurface?.includes('Floor');
      const canWall  = productData.tileSurface?.includes('Wall');
      if (canFloor) return 'floor';
      if (canWall)  return 'wall';
      return 'floor';
    }

    function formatPrice(price) {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: productData.currency || 'GBP',
        minimumFractionDigits: 2
      }).format(price);
    }

    function getPricePerBox() {
      return productData.pricePerSqm * productData.boxCoverage;
    }

    let regularPriceElement = null;
    let salePriceElement = null;
    let priceContainer = null;
    let originalRegularPriceHtml = '';
    let originalSalePriceHtml = '';

    function findAndStorePriceElements() {
      // Variant price is stored as per-box price in Shopify
      // Divide by boxCoverage to derive the per-m2 display price
      const rawDataPrice = parseFloat(section.dataset.price.replace(/,/g, '.'));
      if (!isNaN(rawDataPrice) && rawDataPrice > 0) {
        if (productData.boxCoverage > 0) {
          productData.pricePerSqm = rawDataPrice / productData.boxCoverage;
        } else {
          productData.pricePerSqm = rawDataPrice;
        }
      }

      const productSection = document.querySelector('.product__info-wrapper, [id*="MainProduct"], product-info')
                          || document.querySelector('product-form')?.closest('section, .shopify-section')
                          || document.body;

      regularPriceElement = productSection.querySelector('.price__regular .price-item--regular');
      salePriceElement    = productSection.querySelector('.price__sale .price-item--sale');
      priceContainer      = productSection.querySelector('.price');

      if (regularPriceElement && !originalRegularPriceHtml) {
        originalRegularPriceHtml = regularPriceElement.innerHTML;
      }
      if (salePriceElement && !originalSalePriceHtml) {
        originalSalePriceHtml = salePriceElement.innerHTML;
      }
    }

    function updateDisplayedPrice(boxes, actualArea, totalPrice) {
      if (!regularPriceElement && !salePriceElement) {
        findAndStorePriceElements();
      }

      const formattedTotal  = formatPrice(totalPrice);
      const formattedPerSqm = formatPrice(productData.pricePerSqm);
      const boxLabel        = `${boxes} box${boxes !== 1 ? 'es' : ''}`;

      if (regularPriceElement) {
        regularPriceElement.innerHTML = `${formattedTotal} <span class="price-per-sqm" style="font-size:12px;font-weight:normal;color:#6c757d;margin-left:5px;">for ${boxLabel}</span>`;
      }
      if (salePriceElement) {
        salePriceElement.innerHTML = `${formattedTotal} <span class="price-per-sqm" style="font-size:12px;font-weight:normal;color:#6c757d;margin-left:5px;">for ${boxLabel}</span>`;
      }

      if (priceContainer) {
        let qtyInfo = priceContainer.querySelector('.price-qty-info');
        if (!qtyInfo) {
          qtyInfo = document.createElement('div');
          qtyInfo.className = 'price-qty-info';
          qtyInfo.style.cssText = 'font-size:12px;color:#FB3435;margin-top:4px;margin-bottom:8px;';
          priceContainer.appendChild(qtyInfo);
        }
        qtyInfo.innerHTML = `${actualArea.toFixed(2)}m\u00b2 \u00d7 ${formattedPerSqm}/m\u00b2 = ${formattedTotal}`;
      }
    }

    function resetPriceDisplay() {
      if (regularPriceElement && originalRegularPriceHtml) {
        regularPriceElement.innerHTML = originalRegularPriceHtml;
      }
      if (salePriceElement && originalSalePriceHtml) {
        salePriceElement.innerHTML = originalSalePriceHtml;
      }
      if (priceContainer) {
        const qtyInfo = priceContainer.querySelector('.price-qty-info');
        if (qtyInfo) qtyInfo.remove();
      }
    }

    function parseTileSize(sizeStr) {
      if (!sizeStr) return null;
      const parts = sizeStr.toLowerCase().split('x');
      if (parts.length !== 2) return null;
      const width = parseInt(parts[0].trim());
      const height = parseInt(parts[1].trim());
      if (isNaN(width) || isNaN(height)) return null;
      return { width, height, thickness: 10 };
    }

    function calcArea(l, w) {
      if (!l || !w || isNaN(l) || isNaN(w) || l <= 0 || w <= 0) return 0;
      return parseFloat((l * w).toFixed(4));
    }

    function calcTotalArea() {
      return areas.reduce((sum, a) => sum + calcArea(a.length, a.width), 0);
    }

    function calcFinalArea(total, pct) {
      if (!wasteEnabled || pct <= 0) return total;
      return total * (1 + pct / 100);
    }

    function calculateBoxesNeeded(areaOrdered, coveragePerBox) {
      if (coveragePerBox <= 0) return { boxes: 0, actualArea: 0, extraWaste: 0 };
      const boxes = Math.ceil(areaOrdered / coveragePerBox);
      const actualArea = parseFloat((boxes * coveragePerBox).toFixed(4));
      const extraWaste = areaOrdered > 0
        ? ((actualArea - areaOrdered) / areaOrdered * 100).toFixed(1)
        : '0.0';
      return { boxes, actualArea, extraWaste: parseFloat(extraWaste) };
    }

    function calcAdhesiveBags(area, surface) {
      if (!area || area <= 0) return 0;

      // When decoupling matting is added, extra floor adhesive is needed to
      // bond the matt to the subfloor. Rule from client: 4kg extra per m2
      // of matting. A 20kg bag therefore covers 5 m2 of matting, so we add
      // (mattingSqm * FLOOR_ADHESIVE_COVERAGE / 5) m2 to the effective
      // floor area before dividing by the floor adhesive coverage.
      let effectiveArea = area;
      if (surface === 'floor') {
        const mattToggle = document.getElementById('decoupling-mat-toggle');
        const mattingActive = mattToggle && mattToggle.checked && window.decouplingData && window.decouplingData.isReady;
        if (mattingActive) {
          const mattingSqm = window.decouplingData.quantity || 0;
          if (mattingSqm > 0) {
            effectiveArea = area + (mattingSqm * FLOOR_ADHESIVE_COVERAGE / 5);
          }
        }
      }

      const coverage = surface === 'floor' ? FLOOR_ADHESIVE_COVERAGE : WALL_ADHESIVE_COVERAGE;
      return Math.ceil(effectiveArea / coverage);
    }

    function calculateGroutBags(netArea, jointWidth, tileSize) {
      if (!tileSize || !netArea || netArea <= 0) return 0;
      if (!jointWidth || jointWidth <= 0) return 0;
      const tileW  = tileSize.width  / 1000;
      const tileH  = tileSize.height / 1000;
      const jointM = jointWidth / 1000;
      const depthM = 0.009;
      const tileArea      = tileW * tileH;
      const totalTiles    = netArea / tileArea;
      const tilePerimeter = 2 * tileW + 2 * tileH;
      const linearJoints  = totalTiles * tilePerimeter / 2;
      const groutVolume   = linearJoints * jointM * depthM;
      const groutKg       = groutVolume * 1600;
      return Math.ceil(groutKg / 3);
    }

    const productHandleCache = {};

    async function resolveProductFromHandle(handle) {
      if (!handle || handle === '') return null;
      if (productHandleCache[handle]) return productHandleCache[handle];
      try {
        const response = await fetch(`/products/${handle}.js`);
        if (!response.ok) return null;
        const product = await response.json();
        const result = {
          variantId: product.variants[0]?.id || null,
          pricePerUnit: (product.variants[0]?.price || 0) / 100
        };
        productHandleCache[handle] = result;
        return result;
      } catch (error) {
        console.error('Error resolving product from handle:', error);
        return null;
      }
    }

    async function resolveVariantIdFromHandle(handle) {
      const data = await resolveProductFromHandle(handle);
      return data?.variantId || null;
    }

    function getAreasBySurface() {
      const floorArea = areas
        .filter(a => a.surface === 'floor' && a.area > 0)
        .reduce((sum, a) => sum + a.area, 0);
      const wallArea = areas
        .filter(a => a.surface === 'wall' && a.area > 0)
        .reduce((sum, a) => sum + a.area, 0);
      return { floorArea, wallArea };
    }

    async function updateAdhesiveCalculation() {
      const { floorArea, wallArea } = getAreasBySurface();
      const resultEl = document.getElementById('adhesive-result');
      const items = [];

      if (floorArea > 0 && productData.floorAdhesiveHandle) {
        const prod = await resolveProductFromHandle(productData.floorAdhesiveHandle);
        const bags = calcAdhesiveBags(floorArea, 'floor');
        if (prod?.variantId && bags > 0) {
          items.push({ variantId: prod.variantId, bags, pricePerBag: prod.pricePerUnit, label: 'Floor Adhesive', surface: 'floor' });
        }
      }

      if (wallArea > 0 && productData.wallAdhesiveHandle) {
        const prod = await resolveProductFromHandle(productData.wallAdhesiveHandle);
        const bags = calcAdhesiveBags(wallArea, 'wall');
        if (prod?.variantId && bags > 0) {
          items.push({ variantId: prod.variantId, bags, pricePerBag: prod.pricePerUnit, label: 'Wall Adhesive', surface: 'wall' });
        }
      }

      window.adhesiveData = {
        isReady: items.length > 0,
        items,
        totalPrice: items.reduce((sum, i) => sum + (i.bags * i.pricePerBag), 0)
      };

      if (resultEl && items.length > 0) {
        resultEl.innerHTML = items.map(i =>
          `<strong>\u2713 ${i.label}</strong><br>
           Quantity: ${i.bags} x 20kg bag${i.bags !== 1 ? 's' : ''}
           <span style="font-size:0.7rem;display:block;color:#28a745;">Will be added to cart</span>`
        ).join('<hr style="margin:8px 0">');
      } else if (resultEl) {
        resultEl.innerHTML = '<div class="error-message">Enter area dimensions first</div>';
      }
    }

    async function updateGroutCalculation() {
      const jointWidth = parseFloat(groutJointInput?.value);
      const minJoint = productData.minGrout;
      const resultEl = document.getElementById('grout-result');

      if (!jointWidth || isNaN(jointWidth)) {
        window.groutData = { variantId: null, bags: 0, jointWidth: null, color: null, isReady: false };
        if (resultEl) resultEl.innerHTML = '<div class="error-message">Enter grout joint width</div>';
        return;
      }

      if (jointWidth < minJoint) {
        if (resultEl) resultEl.innerHTML = `<div class="error-message">Minimum joint width is ${minJoint}mm</div>`;
        return;
      }

      if (currentBoxInfo.actualArea === 0) {
        if (resultEl) resultEl.innerHTML = '<div class="error-message">Calculate area dimensions first</div>';
        return;
      }

      // Read the grout product handle from the currently active swatch.
      // Each swatch has its own data-grout-handle pointing to a specific
      // grout product in the store, so the cart picks up the correct image
      // and product page matching the colour the customer selected.
      const activeSwatch = document.querySelector('.color-swatch.active');
      const swatchHandle = activeSwatch ? activeSwatch.dataset.groutHandle : null;
      const groutHandle = swatchHandle || productData.groutProductHandle;

      if (!groutHandle) {
        if (resultEl) resultEl.innerHTML = '<div class="error-message">Grout not available for this tile</div>';
        return;
      }

      const variantId = await resolveVariantIdFromHandle(groutHandle);

      if (!variantId) {
        if (resultEl) resultEl.innerHTML = '<div class="error-message">Grout not available for this tile</div>';
        return;
      }

      const bagsNeeded = calculateGroutBags(currentBoxInfo.actualArea, jointWidth, tileDimensions);
      const groutProd = await resolveProductFromHandle(groutHandle);
      const groutPricePerBag = groutProd?.pricePerUnit || 0;

      window.groutData = {
        variantId,
        bags: bagsNeeded,
        pricePerBag: groutPricePerBag,
        totalPrice: bagsNeeded * groutPricePerBag,
        jointWidth,
        color: selectedGroutColor,
        productHandle: groutHandle,
        isReady: true
      };

      const tileOnlyPrice = productData.pricePerSqm * currentBoxInfo.actualArea;
      updateCartTotalButton(tileOnlyPrice);

      if (resultEl) {
        const swatchLabel = activeSwatch ? (activeSwatch.title || selectedGroutColor) : selectedGroutColor;
        resultEl.innerHTML = `
          <strong>\u2713 Grout selected (${swatchLabel})</strong><br>
          Quantity: ${bagsNeeded} x 3kg bag${bagsNeeded !== 1 ? 's' : ''}
          <span style="font-size:12px; display:block; color: #FB3435;">Will be added to cart</span>
        `;
      }
    }

    async function updateDecouplingMatRecommendation() {
      if (!productData.subfloorRecs) return;
      const needsMatting = selectedSubfloor === 'timber';
      if (!subfloorRecommendationsDiv) return;
      subfloorRecommendationsDiv.style.display = needsMatting ? 'block' : 'none';
      
      if (needsMatting) {
        const { floorArea } = getAreasBySurface();

        if (floorArea <= 0) {
          window.decouplingData = { variantId: null, quantity: 0, isReady: false };
          const resultDiv = document.getElementById('decoupling-mat-result');
          if (resultDiv) {
            resultDiv.innerHTML = `<span style="font-size:13px;color:#6b7280;">No floor areas defined - matting applies to floor areas only.</span>`;
          }
          return;
        }

        const variantId = await resolveVariantIdFromHandle(productData.decouplingMatHandle);
        const sqmNeeded = Math.ceil(floorArea);
        const matProd = await resolveProductFromHandle(productData.decouplingMatHandle);
        const matPricePerSqm = matProd?.pricePerUnit || 0;

        if (variantId && sqmNeeded > 0) {
          window.decouplingData = {
            variantId,
            quantity: sqmNeeded,
            pricePerSqm: matPricePerSqm,
            totalPrice: sqmNeeded * matPricePerSqm,
            isReady: true
          };
          const resultDiv = document.getElementById('decoupling-mat-result');
          if (resultDiv) {
            resultDiv.innerHTML = `
              <strong>\u2713 Decoupling Matting added</strong><br>
              Quantity: ${sqmNeeded} m\u00b2 (covers ${floorArea.toFixed(2)} m\u00b2 floor area)
              <span style="font-size:12px; display:block; color: #FB3435;">Will be added to cart</span>
            `;
          }
        }
      } else {
        window.decouplingData = { variantId: null, quantity: 0, isReady: false };
      }
    }

    function updateCartTotalButton(tilePrice) {
      if (!addToCartBtn || !calculatorReady) return;

      const adhesiveToggle = document.getElementById('adhesive-toggle');
      const groutToggle    = document.getElementById('grout-toggle');
      const adhesiveTotal  = (adhesiveToggle === null || adhesiveToggle.checked) && window.adhesiveData?.isReady ? (window.adhesiveData.totalPrice || 0) : 0;
      const groutTotal     = (groutToggle === null || groutToggle.checked) && window.groutData?.isReady ? (window.groutData.totalPrice || 0) : 0;
      const mattingTotal  = (decouplingMatToggle?.checked && window.decouplingData?.isReady)
                              ? (window.decouplingData.totalPrice || 0)
                              : 0;

      const grandTotal = tilePrice + adhesiveTotal + groutTotal + mattingTotal;
      const formattedPerSqm = formatPrice(productData.pricePerSqm);
      const parts = [`Tiles: ${formatPrice(tilePrice)} (${currentBoxInfo.actualArea.toFixed(2)}m\u00b2 @ ${formattedPerSqm}/m\u00b2)`];
      if (adhesiveTotal > 0) parts.push(`Adhesive: ${formatPrice(adhesiveTotal)}`);
      if (groutTotal > 0)    parts.push(`Grout: ${formatPrice(groutTotal)}`);
      if (mattingTotal > 0)  parts.push(`Matting: ${formatPrice(mattingTotal)}`);

      addToCartBtn.disabled = false;
      addToCartBtn.innerHTML = `
        \uD83D\uDED2 Add to Cart - ${formatPrice(grandTotal)}
        <span style="display:block;font-size:11px;font-weight:400;opacity:0.85;margin-top:2px;">
          ${parts.join(' \u00b7 ')}
        </span>
      `;
    }

    async function updateCalculations() {
      if (productData.pricePerSqm === 0) {
        findAndStorePriceElements();
      }
      
      const totalArea = calcTotalArea();
      currentRawTotalArea = totalArea;
      const finalAreaRaw = calcFinalArea(totalArea, wastePercent);
      currentBoxInfo = calculateBoxesNeeded(finalAreaRaw, productData.boxCoverage);

      const pricePerBox = getPricePerBox();
      const totalPrice = currentBoxInfo.boxes * pricePerBox;
      
      const totalAreaEl       = document.getElementById('result-total-area');
      const finalAreaEl       = document.getElementById('result-final-area');
      const wasteRow          = document.getElementById('result-waste-row');
      const wasteAmountEl     = document.getElementById('result-waste-amount');
      const boxInfoRow        = document.getElementById('result-box-info');
      const boxesCountEl      = document.getElementById('result-boxes-count');
      const actualAreaRow     = document.getElementById('result-actual-area');
      const actualAreaValueEl = document.getElementById('result-actual-area-value');
      const totalPriceEl      = document.getElementById('result-total-price');
      
      if (totalAreaEl) totalAreaEl.innerHTML = `<strong>${totalArea.toFixed(2)} m\u00b2</strong>`;
      if (finalAreaEl) finalAreaEl.innerHTML = `<strong>${finalAreaRaw.toFixed(2)} m\u00b2</strong>`;
      
      if (wasteEnabled && wastePercent > 0 && totalArea > 0) {
        if (wasteAmountEl) wasteAmountEl.innerHTML = `+${wastePercent}% = ${(totalArea * wastePercent / 100).toFixed(2)} m\u00b2`;
        if (wasteRow) wasteRow.style.display = 'flex';
      } else {
        if (wasteRow) wasteRow.style.display = 'none';
      }
      
      if (productData.boxCoverage > 0 && currentBoxInfo.boxes > 0) {
        if (boxInfoRow) boxInfoRow.style.display = 'flex';
        if (boxesCountEl) boxesCountEl.innerHTML = `<strong>${currentBoxInfo.boxes} boxes</strong> (${currentBoxInfo.actualArea.toFixed(2)} m\u00b2 total)`;
        if (actualAreaRow) actualAreaRow.style.display = 'flex';
        if (actualAreaValueEl) actualAreaValueEl.innerHTML = `${currentBoxInfo.actualArea.toFixed(2)} m\u00b2 <span style="font-size:12px;color:#fb3435;">(+${currentBoxInfo.extraWaste}% extra)</span>`;
      }

      const formattedPerSqm = formatPrice(productData.pricePerSqm);
      if (totalPriceEl) {
        totalPriceEl.innerHTML = `
          ${formatPrice(totalPrice)}
          <span style="font-size:12px;font-weight:normal;color:#6b7280;">
            (${currentBoxInfo.actualArea.toFixed(2)} m\u00b2 \u00d7 ${formattedPerSqm}/m\u00b2)
          </span>`;
      }
      
      if (currentBoxInfo.boxes > 0 && productData.pricePerSqm > 0) {
        if (resultsDiv) resultsDiv.style.display = 'block';
        if (adhesiveSection) adhesiveSection.style.display = 'block';
        if (groutSection) groutSection.style.display = 'block';
        
        calculatorReady = true;
        updateDisplayedPrice(currentBoxInfo.boxes, currentBoxInfo.actualArea, totalPrice);
        if (productData.subfloorRecs) await updateDecouplingMatRecommendation();
        await updateAdhesiveCalculation();
        if (groutJointInput?.value) await updateGroutCalculation();
        updateCartTotalButton(totalPrice);
      } else {
        if (addToCartBtn) {
          addToCartBtn.disabled = true;
          addToCartBtn.innerHTML = '\u2699\uFE0F Enter area dimensions first';
        }
        resetPriceDisplay();
      }
    }

    function renderAreas() {
      if (!areasContainer) return;
      areasContainer.innerHTML = '';

      const showSurfaceToggle = productData.tileSurface?.includes('Floor') && productData.tileSurface?.includes('Wall');

      areas.forEach((area, index) => {
        const div = document.createElement('div');
        div.className = 'area-row';
        div.dataset.areaIndex = index;
        div.innerHTML = `
          <span class="area-label">Area ${index + 1}</span>
          <div class="area-inputs">
            <input type="number" class="area-length" placeholder="Length (m)" step="any" min="0.1" max="20" value="${area.length || ''}">
            <span class="area-times">\u00d7</span>
            <input type="number" class="area-width" placeholder="Width (m)" step="any" min="0.1" max="20" value="${area.width || ''}">
            <span class="area-size">${area.area.toFixed(2)} m\u00b2</span>
            <button type="button" class="remove-area"${areas.length === 1 ? ' style="display:none"' : ''}>Remove</button>
          </div>
          ${showSurfaceToggle ? `
          <div class="area-surface-toggle">
            <button type="button" class="surface-toggle-btn ${area.surface === 'floor' ? 'active' : ''}" data-surface="floor">Floor</button>
            <button type="button" class="surface-toggle-btn ${area.surface === 'wall' ? 'active' : ''}" data-surface="wall">Wall</button>
          </div>` : ''}`;

        const lengthInput = div.querySelector('.area-length');
        const widthInput  = div.querySelector('.area-width');
        const areaSpan    = div.querySelector('.area-size');

        const onAreaChange = () => {
          const l = parseFloat(lengthInput.value) || 0;
          const w = parseFloat(widthInput.value) || 0;
          const a = calcArea(l, w);
          areaSpan.innerText = a.toFixed(2) + ' m\u00b2';
          areas[index] = { ...areas[index], length: l, width: w, area: a };
          updateCalculations();
        };

        lengthInput.addEventListener('input', onAreaChange);
        widthInput.addEventListener('input', onAreaChange);

        div.querySelector('.remove-area')?.addEventListener('click', () => {
          if (areas.length > 1) {
            areas.splice(index, 1);
            renderAreas();
            updateCalculations();
          }
        });

        div.querySelectorAll('.surface-toggle-btn').forEach(btn => {
          btn.addEventListener('click', () => {
            div.querySelectorAll('.surface-toggle-btn').forEach(b => b.classList.remove('active'));
            btn.classList.add('active');
            areas[index].surface = btn.dataset.surface;
            updateCalculations();
          });
        });

        areasContainer.appendChild(div);
      });
    }

    function addArea() {
      areas.push({ length: '', width: '', area: 0, surface: getDefaultSurface() });
      renderAreas();
    }

    function updateWaste() {
      wasteEnabled = wasteToggle.checked;
      if (wasteControls) wasteControls.style.display = wasteEnabled ? 'block' : 'none';
      if (wasteEnabled && patternSelect.value !== 'custom') {
        const preset = { 'straight': 10, 'brick-bond': 10, 'herringbone': 15, 'diagonal': 15 };
        wastePercent = preset[patternSelect.value] || 10;
        if (wastePctInput) wastePctInput.value = wastePercent;
      }
      updateCalculations();
    }

    function onPatternChange() {
      if (patternSelect.value === 'custom') {
        wastePercent = parseFloat(wastePctInput.value) || 0;
      } else {
        const preset = { 'straight': 10, 'brick-bond': 10, 'herringbone': 15, 'diagonal': 15 };
        wastePercent = preset[patternSelect.value];
        if (wastePctInput) wastePctInput.value = wastePercent;
      }
      updateCalculations();
    }

    function initGroutColorSwatches() {
      colorSwatches.forEach(swatch => {
        swatch.addEventListener('click', () => {
          colorSwatches.forEach(s => s.classList.remove('active'));
          swatch.classList.add('active');
          selectedGroutColor = swatch.dataset.color;
          document.getElementById('grout-color').value = selectedGroutColor;
          if (groutJointInput?.value) updateGroutCalculation();
        });
      });
      const defaultSwatch = document.querySelector('.color-swatch[data-color="white"]');
      if (defaultSwatch) defaultSwatch.classList.add('active');
    }

    function initSubfloorSelector() {
      if (!subfloorRadios.length) return;
      subfloorRadios.forEach(radio => {
        radio.addEventListener('change', async (e) => {
          if (e.target.checked) {
            selectedSubfloor = e.target.value;
            if (subfloorWarning) {
              subfloorWarning.style.display = selectedSubfloor === 'timber' ? 'block' : 'none';
            }
            const existingTilesNote = document.getElementById('existing-tiles-note');
            if (existingTilesNote) {
              existingTilesNote.style.display = selectedSubfloor === 'existing' ? 'block' : 'none';
            }
            await updateDecouplingMatRecommendation();
            await updateAdhesiveCalculation();
            const tilePrice = productData.pricePerSqm * currentBoxInfo.actualArea;
            updateCartTotalButton(tilePrice);
          }
        });
      });
    }

    async function refreshAndOpenCartDrawer() {
      const cartDrawerEl = document.querySelector('cart-drawer');
      try {
        const sectionsToRender = (cartDrawerEl && typeof cartDrawerEl.getSectionsToRender === 'function')
          ? cartDrawerEl.getSectionsToRender()
          : [{ id: 'cart-drawer', selector: '#CartDrawer' }, { id: 'cart-icon-bubble' }];

        const sectionIds = sectionsToRender.map(s => s.id).filter(Boolean);
        const sectionsRes = await fetch(`${window.location.pathname}?sections=${sectionIds.join(',')}`);
        if (!sectionsRes.ok) throw new Error(`Sections fetch HTTP ${sectionsRes.status}`);
        const sectionsHtml = await sectionsRes.json();

        if (cartDrawerEl && typeof cartDrawerEl.renderContents === 'function') {
          cartDrawerEl.renderContents({ sections: sectionsHtml });
        } else {
          sectionsToRender.forEach(section => {
            const html = sectionsHtml[section.id];
            if (!html) return;
            const target = section.selector
              ? document.querySelector(section.selector)
              : document.getElementById(section.id);
            if (!target) return;
            const parsed = new DOMParser().parseFromString(html, 'text/html');
            const source = section.selector
              ? parsed.querySelector(section.selector)
              : (parsed.getElementById(section.id) || parsed.querySelector('.shopify-section'));
            if (source) target.innerHTML = source.innerHTML;
          });
        }

        if (cartDrawerEl) {
          cartDrawerEl.classList.remove('is-empty');
          if (typeof cartDrawerEl.open === 'function') cartDrawerEl.open();
        }
      } catch (err) {
        console.warn('refreshAndOpenCartDrawer error:', err);
        if (cartDrawerEl && typeof cartDrawerEl.open === 'function') {
          cartDrawerEl.classList.remove('is-empty');
          cartDrawerEl.open();
        } else {
          const cartBtn = document.querySelector('#cart-icon-bubble');
          if (cartBtn) cartBtn.click();
        }
      }
    }

    async function updateCartCount() {
      try {
        const response = await fetch('/cart.js');
        if (!response.ok) return;
        const cart = await response.json();
        const cartCountElements = document.querySelectorAll('.cart-count-bubble, .cart__count, .cart-count, [data-cart-count]');
        cartCountElements.forEach(el => {
          if (el) el.innerText = cart.item_count;
        });
        window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
        return cart;
      } catch (error) {
        console.error('Error updating cart count:', error);
      }
    }

    function showAddToCartSuccess(itemCount) {
      const notification = document.createElement('div');
      notification.style.cssText = `
        position: fixed; bottom: 20px; right: 20px; background: #FB3435;
        color: white; padding: 12px 20px; border-radius: 8px; font-size: 14px;
        z-index: 10000; box-shadow: 0 2px 10px rgba(0,0,0,0.2);
        animation: slideInRight 0.3s ease;
      `;
      notification.innerHTML = `\u2713 Added to cart! ${itemCount} item${itemCount !== 1 ? 's' : ''}`;
      document.body.appendChild(notification);
      setTimeout(() => {
        notification.style.animation = 'slideOutRight 0.3s ease';
        setTimeout(() => notification.remove(), 300);
      }, 3000);
    }

    const SAMPLE_KEY = 'jt_samples';
    const MAX_SAMPLES = 3;
    let currentSamples = [];
    let cachedSampleVariants = [];
    let sampleButtonLoading = false;

    async function getSampleVariants() {
      if (cachedSampleVariants.length > 0) return cachedSampleVariants;
      try {
        const handlesToTry = ['tile-sample', 'sample', 'sample-product'];
        for (const handle of handlesToTry) {
          const response = await fetch(`/products/${handle}.js`);
          if (response.ok) {
            const product = await response.json();
            if (product.variants && product.variants.length > 0) {
              cachedSampleVariants = product.variants.map(v => ({
                id: v.id,
                price: parseFloat(v.price),
                title: v.title,
                available: v.available !== false
              }));
              return cachedSampleVariants;
            }
          }
        }
        return [];
      } catch (error) {
        console.error('Error finding sample product:', error);
        return [];
      }
    }

    async function getSampleVariantForQuantity(quantity) {
      const variants = await getSampleVariants();
      if (variants.length === 0) return null;
      // All sample variants are £0.00. The actual sample charge is handled
      // entirely by the "Tile Samples" shipping rate in Shopify admin, based
      // on cart weight (each sample variant weighs 10g). This avoids the old
      // per-variant pricing trick, which could be exploited by adding two
      // samples then deleting the priced line, leaving only £0.00 lines.
      // We still rotate through the available variants so each sample gets
      // its own line item and Shopify never merges them.
      const index = Math.min(Math.max(quantity - 1, 0), variants.length - 1);
      return variants[index];
    }

    function setSampleButtonLoading(loading) {
      if (!sampleBtn) return;
      sampleButtonLoading = loading;
      if (loading) {
        sampleBtn.dataset.origText = sampleBtn.innerText;
        sampleBtn.disabled = true;
        sampleBtn.innerHTML = '<span class="sample-loading-spinner"></span> Updating samples...';
      } else {
        sampleBtn.disabled = false;
        sampleBtn.innerHTML = sampleBtn.dataset.origText || 'Request a Sample';
        delete sampleBtn.dataset.origText;
        updateSampleUI();
      }
    }

    function loadSamples() {
      try {
        currentSamples = JSON.parse(localStorage.getItem(SAMPLE_KEY)) || [];
      } catch(e) { currentSamples = []; }
      updateSampleUI();
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => syncSamplesWithCart(cart))
        .catch(() => {});
    }

    function saveSamples() {
      localStorage.setItem(SAMPLE_KEY, JSON.stringify(currentSamples));
      updateSampleUI();
    }

    async function syncSamplesWithCart(cart) {
      const variants = await getSampleVariants();
      const variantIds = variants.map(v => v.id);

      // Find every cart line item that is a sample. Each sample is its own
      // line because of the unique _sample_id property, so total samples =
      // sum of quantities across all sample line items.
      const sampleLineItems = cart.items.filter(i =>
        variantIds.includes(i.variant_id) || (i.properties && i.properties['Tile'])
      );

      const rebuilt = [];
      for (const line of sampleLineItems) {
        const title = (line.properties?.['Tile'] || '').replace(' - Sample', '').trim();
        if (!title) continue;
        for (let i = 0; i < line.quantity; i++) {
          if (rebuilt.length < MAX_SAMPLES) {
            rebuilt.push({
              productId: line.properties?.['_product_id'] || '',
              productTitle: title,
              addedAt: Date.now()
            });
          }
        }
      }

      const changed = rebuilt.length !== currentSamples.length;
      if (changed) {
        currentSamples = rebuilt;
        localStorage.setItem(SAMPLE_KEY, JSON.stringify(currentSamples));
        updateSampleUI();
      }
    }

    function updateSampleUI() {
      const count = currentSamples.length;
      if (sampleCounterSpan) {
        sampleCounterSpan.innerText = count > 0 ? `${count} of ${MAX_SAMPLES} selected` : '';
      }
      if (sampleBtn && !sampleButtonLoading) {
        if (count >= MAX_SAMPLES) {
          sampleBtn.disabled = true;
          sampleBtn.innerText = 'Maximum Sample Capacity Reached';
        } else {
          sampleBtn.disabled = false;
          sampleBtn.innerText = 'Request A Sample';
        }
      }
    }

    async function addOneSampleToCart(sampleNumber) {
      const variant = await getSampleVariantForQuantity(sampleNumber);
      if (!variant) {
        throw new Error('Sample product variant not available');
      }

      // Unique ID per sample line so Shopify never merges samples into one
      // line, even if the same tile is added twice. This is the core fix
      // for the "second sample overrides first" bug.
      const uniqueSampleId = `${productData.id}_${Date.now()}_${Math.floor(Math.random() * 1000)}`;

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: variant.id,
            quantity: 1,
            properties: {
              'Tile': `${productData.title} - Sample`,
              '_sample_id': uniqueSampleId,
              '_product_id': String(productData.id),
              '_sample_number': String(sampleNumber)
            }
          }]
        })
      });

      if (!response.ok) {
        let detail = '';
        try {
          const errBody = await response.json();
          detail = errBody.description || errBody.message || '';
        } catch (e) { /* ignore */ }
        throw new Error(`Failed to add sample (HTTP ${response.status})${detail ? ': ' + detail : ''}`);
      }

      currentSamples.push({
        productId: productData.id,
        productTitle: productData.title,
        addedAt: Date.now()
      });
      saveSamples();
      return true;
    }

    async function handleSampleRequest() {
      // Always sync with the actual cart first - localStorage can be stale
      // especially when the customer arrives via a URL link (e.g. from the
      // visualiser) where they may have samples in the cart from a prior
      // session that localStorage does not know about.
      try {
        const cartRes = await fetch('/cart.js');
        if (cartRes.ok) {
          const cart = await cartRes.json();
          await syncSamplesWithCart(cart);
        }
      } catch (e) { /* fall back to localStorage count */ }

      const currentCount = currentSamples.length;

      if (currentCount >= MAX_SAMPLES) {
        showSampleMaxPopup();
        return;
      }

      const newSampleNumber = currentCount + 1;

      setSampleButtonLoading(true);
      try {
        await addOneSampleToCart(newSampleNumber);
        await updateCartCount();
        await refreshAndOpenCartDrawer();
        if (newSampleNumber >= MAX_SAMPLES) showSampleMaxPopup();
      } catch (err) {
        console.error('Sample request error:', err);
        alert('Something went wrong: ' + err.message);
      } finally {
        setSampleButtonLoading(false);
      }
    }

    function showSampleMaxPopup() {
      const overlay = document.createElement('div');
      overlay.className = 'sample-popup-overlay';
      overlay.innerHTML = `
        <div class="sample-popup">
          <h4>Maximum Samples Reached</h4>
          <p>You have selected the maximum of ${MAX_SAMPLES} samples.</p>
          <div class="popup-buttons">
            <button class="popup-continue">Continue Browsing</button>
            <button class="popup-checkout">Proceed to Checkout</button>
          </div>
        </div>
      `;
      document.body.appendChild(overlay);
      overlay.querySelector('.popup-continue')?.addEventListener('click', () => overlay.remove());
      overlay.querySelector('.popup-checkout').addEventListener('click', () => window.location.href = '/checkout');
      overlay.addEventListener('click', (e) => { if (e.target === overlay) overlay.remove(); });
    }

    async function handleAddToCart(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      
      if (!calculatorReady || currentBoxInfo.boxes === 0) {
        alert('Please calculate your area dimensions first');
        return;
      }

      const items = [];
      
      let variantId = null;
      const variantInput = document.querySelector('[name="id"]');
      if (variantInput) variantId = parseInt(variantInput.value, 10);

      if (!variantId || isNaN(variantId)) {
        const variantSelect = document.querySelector('form[action*="/cart/add"] input[name="id"], .product-variant-id');
        if (variantSelect) variantId = parseInt(variantSelect.value, 10);
      }

      if (!variantId || isNaN(variantId)) {
        alert('Unable to add to cart. Please refresh and try again.');
        return;
      }
      
      const wasteText   = wasteEnabled ? `${wastePercent}% Waste Allowance` : 'No Waste Allowance';
      const patternName = patternSelect?.options[patternSelect.selectedIndex]?.text || 'Straight Lay';
      const areasSummary = areas
        .filter(a => a.length && a.width && a.area > 0)
        .map((a, i) => `Area ${i + 1}: ${a.length}m \u00d7 ${a.width}m = ${a.area.toFixed(2)}m\u00b2 (${a.surface})`)
        .join(', ');

      items.push({
        id: variantId,
        quantity: currentBoxInfo.boxes,
        properties: {
          'Boxes':           `${currentBoxInfo.boxes} box${currentBoxInfo.boxes !== 1 ? 'es' : ''}`,
          'Area Covered':    `${currentBoxInfo.actualArea.toFixed(2)} m\u00b2`,
          'Area Required':   `${calcFinalArea(currentRawTotalArea, wastePercent).toFixed(2)} m\u00b2`,
          'Waste Allowance': wasteText,
          'Laying Pattern':  patternName,
          'Room Details':    areasSummary || 'Single area installation'
        }
      });
      
      const adhesiveToggleEl = document.getElementById('adhesive-toggle');
      if ((adhesiveToggleEl === null || adhesiveToggleEl.checked) && window.adhesiveData?.isReady && window.adhesiveData.items?.length > 0) {
        window.adhesiveData.items.forEach(item => {
          items.push({
            id: item.variantId,
            quantity: item.bags,
            properties: {
              'Type':        item.label,
              'For Product': productData.title,
              'Surface':     item.surface === 'floor' ? 'Floor Installation' : 'Wall Installation'
            }
          });
        });
      }

      const groutToggleEl = document.getElementById('grout-toggle');
      if ((groutToggleEl === null || groutToggleEl.checked) && window.groutData.isReady && window.groutData.variantId) {
        items.push({
          id: window.groutData.variantId,
          quantity: window.groutData.bags,
          properties: {
            'Type':        'Grout',
            'Colour':      selectedGroutColor,
            'Joint Width': `${window.groutData.jointWidth}mm`
          }
        });
      }
      
      if (decouplingMatToggle?.checked && window.decouplingData.isReady && window.decouplingData.variantId) {
        items.push({
          id: window.decouplingData.variantId,
          quantity: window.decouplingData.quantity,
          properties: {
            'Type':        'Decoupling Matting',
            'For Product': productData.title,
            'Subfloor':    'Timber'
          }
        });
      }
      
      try {
        if (addToCartBtn) {
          addToCartBtn.disabled = true;
          addToCartBtn.innerHTML = 'Adding to cart...';
        }
        
        const currentCart = await fetch('/cart.js').then(res => res.json());
        const updates = {};
        
        currentCart.items
          .filter(i => i.variant_id === variantId && !(i.properties && i.properties['Type']))
          .forEach(i => { updates[i.key] = 0; });
        
        if (window.adhesiveData?.items?.length > 0) {
          window.adhesiveData.items.forEach(adhesiveItem => {
            currentCart.items
              .filter(i => i.variant_id === adhesiveItem.variantId && i.properties?.['Type'] === adhesiveItem.label)
              .forEach(i => { updates[i.key] = 0; });
          });
        }
        
        if (window.groutData.variantId) {
          currentCart.items
            .filter(i => i.variant_id === window.groutData.variantId && i.properties?.['Type'] === 'Grout')
            .forEach(i => { updates[i.key] = 0; });
        }
        
        if (decouplingMatToggle?.checked && window.decouplingData.variantId) {
          currentCart.items
            .filter(i => i.variant_id === window.decouplingData.variantId && i.properties?.['Type'] === 'Decoupling Matting')
            .forEach(i => { updates[i.key] = 0; });
        }
        
        if (Object.keys(updates).length > 0) {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
          });
        }
        
        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });
        
        if (!addResponse.ok) {
          const errorText = await addResponse.text();
          throw new Error(errorText || 'Cart add failed');
        }
        
        await new Promise(resolve => setTimeout(resolve, 300));
        await Promise.all([updateCartCount(), refreshAndOpenCartDrawer()]);
        showAddToCartSuccess(items.length);
        
      } catch (error) {
        console.error('Add to cart error:', error);
        alert('Something went wrong: ' + error.message);
      } finally {
        if (addToCartBtn) {
          addToCartBtn.disabled = false;
          const tilePrice = productData.pricePerSqm * currentBoxInfo.actualArea;
          addToCartBtn.innerHTML = '\uD83D\uDED2 Add to Cart - ' + formatPrice(tilePrice);
        }
      }
    }

    function setupAddToCartOverride() {
      setTimeout(() => {
        const webComp = document.querySelector('product-form');
        const form = webComp
          ? webComp.querySelector('form')
          : document.querySelector('form[action*="/cart/add"]');
        if (!form) {
          setTimeout(setupAddToCartOverride, 500);
          return;
        }
        form.removeEventListener('submit', handleAddToCart);
        form.addEventListener('submit', handleAddToCart);
      }, 100);
    }

    function watchForProductForm() {
      new MutationObserver((mutations) => {
        for (const { addedNodes } of mutations) {
          for (const node of addedNodes) {
            if (node.nodeType === 1 &&
                (node.tagName === 'PRODUCT-FORM' || node.querySelector?.('product-form'))) {
              setupAddToCartOverride();
            }
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }

    function setupCartWatcher() {
      let lastHash = '';
      setInterval(async () => {
        try {
          const res  = await fetch('/cart.js');
          const cart = await res.json();
          const hash = JSON.stringify(cart.items.map(i => ({ id: i.id, props: i.properties, qty: i.quantity })));
          if (hash !== lastHash) {
            lastHash = hash;
            await syncSamplesWithCart(cart);
          }
        } catch { /* silent */ }
      }, 3000);
    }

    if (addAreaBtn)    addAreaBtn.addEventListener('click', addArea);
    if (wasteToggle)   wasteToggle.addEventListener('change', updateWaste);
    if (patternSelect) patternSelect.addEventListener('change', onPatternChange);
    if (wastePctInput) wastePctInput.addEventListener('input', onPatternChange);
    if (addToCartBtn)  addToCartBtn.addEventListener('click', handleAddToCart);
    
    if (groutJointInput) {
      groutJointInput.min         = productData.minGrout;
      groutJointInput.placeholder = `Min ${productData.minGrout}mm`;
      groutJointInput.addEventListener('input', () => updateGroutCalculation());
    }
    
    if (minGroutHint) minGroutHint.innerText = `Minimum: ${productData.minGrout}mm`;
    if (sampleBtn)    sampleBtn.addEventListener('click', handleSampleRequest);

    if (decouplingMatToggle) {
      decouplingMatToggle.addEventListener('change', async () => {
        await updateAdhesiveCalculation();
        const tilePrice = productData.pricePerSqm * currentBoxInfo.actualArea;
        updateCartTotalButton(tilePrice);
      });
    }

    document.addEventListener('change', (e) => {
      if (e.target.id === 'adhesive-toggle' || e.target.id === 'grout-toggle') {
        const tilePrice = productData.pricePerSqm * currentBoxInfo.actualArea;
        updateCartTotalButton(tilePrice);
      }
    });
    
    tileDimensions = parseTileSize(productData.tileSize);
    
    setTimeout(() => findAndStorePriceElements(), 500);

    function initCalcModeTabs() {
      const tabs = document.querySelectorAll('.calc-mode-tab');
      const roomDiv          = document.getElementById('calc-mode-room');
      const areaDiv          = document.getElementById('calc-mode-area');
      const boxesDiv         = document.getElementById('calc-mode-boxes');
      const directAreaInput  = document.getElementById('direct-area-input');
      const directBoxesInput = document.getElementById('direct-boxes-input');
      const directBoxesArea  = document.getElementById('direct-boxes-area');
      const addAreaButton    = document.getElementById('tile-calc__add-area');
      const wasteSection     = document.querySelector('.tile-calc__waste');

      if (!tabs.length) return;

      tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          tabs.forEach(t => t.classList.remove('active'));
          tab.classList.add('active');
          const mode = tab.dataset.mode;

          roomDiv.style.display  = mode === 'room'  ? 'block' : 'none';
          areaDiv.style.display  = mode === 'area'  ? 'block' : 'none';
          boxesDiv.style.display = mode === 'boxes' ? 'block' : 'none';

          if (addAreaButton) addAreaButton.style.display = mode === 'room' ? 'block' : 'none';
          if (wasteSection)  wasteSection.style.display  = mode === 'boxes' ? 'none' : 'block';

          areas = [{ length: '', width: '', area: 0, surface: getDefaultSurface() }];
          currentBoxInfo = { boxes: 0, actualArea: 0, extraWaste: 0 };
          calculatorReady = false;

          if (directAreaInput)  directAreaInput.value  = '';
          if (directBoxesInput) directBoxesInput.value = '';
          if (directBoxesArea)  directBoxesArea.textContent = '';

          renderAreas();
          updateCalculations();
        });
      });

      var directAreaSurface = getDefaultSurface();
      var directBoxesSurface = getDefaultSurface();

      document.querySelectorAll('#direct-area-surface-floor, #direct-area-surface-wall').forEach(function(btn) {
        btn.addEventListener('click', function() {
          document.querySelectorAll('#direct-area-surface-floor, #direct-area-surface-wall').forEach(function(b) { b.classList.remove('active'); });
          btn.classList.add('active');
          directAreaSurface = btn.dataset.surface;
          if (directAreaInput && parseFloat(directAreaInput.value) > 0) {
            var val = parseFloat(directAreaInput.value);
            areas = [{ length: val, width: 1, area: val, surface: directAreaSurface }];
            updateCalculations();
          }
        });
      });

      document.querySelectorAll('#direct-boxes-surface-floor, #direct-boxes-surface-wall').forEach(function(btn) {
        btn.addEventListener('click', function() {
          document.querySelectorAll('#direct-boxes-surface-floor, #direct-boxes-surface-wall').forEach(function(b) { b.classList.remove('active'); });
          btn.classList.add('active');
          directBoxesSurface = btn.dataset.surface;
          if (directBoxesInput && parseInt(directBoxesInput.value) > 0) {
            var boxes = parseInt(directBoxesInput.value);
            var actualArea = parseFloat((boxes * productData.boxCoverage).toFixed(4));
            currentBoxInfo = { boxes: boxes, actualArea: actualArea, extraWaste: 0 };
            areas = [{ length: actualArea, width: 1, area: actualArea, surface: directBoxesSurface }];
            updateAdhesiveCalculation();
            var tilePrice = productData.pricePerSqm * actualArea;
            updateCartTotalButton(tilePrice);
          }
        });
      });

      if (directAreaInput) {
        directAreaInput.addEventListener('input', () => {
          const val = parseFloat(directAreaInput.value) || 0;
          if (val > 0) {
            areas = [{ length: val, width: 1, area: val, surface: directAreaSurface }];
          } else {
            areas = [{ length: '', width: '', area: 0, surface: getDefaultSurface() }];
          }
          updateCalculations();
        });
      }

      if (directBoxesInput) {
        directBoxesInput.addEventListener('input', () => {
          const boxes = parseInt(directBoxesInput.value) || 0;
          if (boxes > 0 && productData.boxCoverage > 0) {
            const actualArea = parseFloat((boxes * productData.boxCoverage).toFixed(4));
            currentBoxInfo   = { boxes, actualArea, extraWaste: 0 };
            areas = [{ length: actualArea, width: 1, area: actualArea, surface: directBoxesSurface }];
            if (directBoxesArea) {
              directBoxesArea.textContent = 'Covers ' + actualArea.toFixed(2) + ' m\u00b2';
            }
            const pricePerBox = getPricePerBox();
            const totalPrice  = boxes * pricePerBox;
            calculatorReady   = true;

            const totalPriceEl  = document.getElementById('result-total-price');
            const boxesCountEl  = document.getElementById('result-boxes-count');
            const actualAreaEl  = document.getElementById('result-actual-area-value');
            const boxInfoRow    = document.getElementById('result-box-info');
            const actualAreaRow = document.getElementById('result-actual-area');
            const resultsDiv    = document.getElementById('tile-calc__results');

            if (resultsDiv)    resultsDiv.style.display    = 'block';
            if (boxInfoRow)    boxInfoRow.style.display    = 'flex';
            if (actualAreaRow) actualAreaRow.style.display = 'flex';
            if (boxesCountEl)  boxesCountEl.innerHTML = '<strong>' + boxes + ' boxes</strong> (' + actualArea.toFixed(2) + ' m\u00b2 total)';
            if (actualAreaEl)  actualAreaEl.textContent = actualArea.toFixed(2) + ' m\u00b2';
            if (totalPriceEl) {
              totalPriceEl.innerHTML = formatPrice(totalPrice) +
                ' <span style="font-size:12px;font-weight:normal;color:#6b7280;">(' +
                actualArea.toFixed(2) + ' m\u00b2 \u00d7 ' + formatPrice(productData.pricePerSqm) + '/m\u00b2)</span>';
            }

            updateDisplayedPrice(boxes, actualArea, totalPrice);
            updateAdhesiveCalculation();
            updateCartTotalButton(totalPrice);
          } else {
            currentBoxInfo  = { boxes: 0, actualArea: 0, extraWaste: 0 };
            calculatorReady = false;
            if (directBoxesArea) directBoxesArea.textContent = '';
            const resultsDiv = document.getElementById('tile-calc__results');
            if (resultsDiv) resultsDiv.style.display = 'none';
            if (addToCartBtn) {
              addToCartBtn.disabled = true;
              addToCartBtn.innerHTML = '\u2699\uFE0F Enter area dimensions first';
            }
            resetPriceDisplay();
          }
        });
      }
    }
    
    initCalcModeTabs();
    renderAreas();
    loadSamples();
    initGroutColorSwatches();
    initSubfloorSelector();
    setupAddToCartOverride();
    watchForProductForm();
    setupCartWatcher();
    findAndStorePriceElements();
    updateCalculations();

    // Auto-trigger sample request when arriving at this page via the
    // visualiser CTA link e.g. /products/handle#order-sample
    // The visualiser developer uses these URLs to add a sample to the
    // cart from outside the storefront. We sync with the cart first so
    // the correct sample variant (and price) is used.
    if (window.location.hash === '#order-sample' && sampleBtn) {
      setTimeout(async () => {
        try {
          const cartRes = await fetch('/cart.js');
          if (cartRes.ok) {
            const cart = await cartRes.json();
            await syncSamplesWithCart(cart);
          }
        } catch (e) { /* fall back */ }

        if (!sampleBtn.disabled && currentSamples.length < MAX_SAMPLES) {
          sampleBtn.click();
        } else if (currentSamples.length >= MAX_SAMPLES) {
          showSampleMaxPopup();
        }
        // Clear the hash so a page refresh does not re-trigger the action
        history.replaceState(null, '', window.location.pathname + window.location.search);
      }, 600);
    }
  }
})();
